(function () {
    'use strict';

    var RING = 64;
    var TAU = Math.PI * 2;

    var SCENES = {
        drop: {
            margin: 0.16,
            edge: 0.17,
            shadow: 0,
            k: 0,
            blobs: [{ x: 0.5, y: 0.502, r: 0.434, seed: 1.7, drift: 0, odd: 0.02 }],
            bubbles: { count: 30, min: 0.008, max: 0.13 }
        },
        cluster: {
            margin: 0.06,
            edge: 0.13,
            shadow: 1,
            k: 0.045,
            blobs: [
                { x: 0.43, y: 0.64, r: 0.355, seed: 4.2, drift: 0.01, odd: 0.07 },
                { x: 0.745, y: 0.205, r: 0.152, seed: 2.9, drift: 0.014, odd: 0.05 },
                { x: 0.845, y: 0.385, r: 0.1, seed: 0.6, drift: 0.018, odd: 0.04 }
            ],
            bubbles: { count: 46, min: 0.007, max: 0.12 }
        }
    };

    var STIFF = 60, DAMP = 2.6, TENSION = 220, POKE = 4, REACH = 0.24, DRAG = 1.3;
    var B_STIFF = 38, B_DAMP = 5.5, B_PUSH = 2;

    var VERT = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';

    function fragment(maxBubbles) {
        return [
            'precision highp float;',
            'uniform vec4 uP0;',
            'uniform vec4 uP1;',
            'uniform vec4 uBlob[3];',
            'uniform vec4 uMode[3];',
            'uniform vec3 uSeed;',
            'uniform vec4 uPtr;',
            'uniform vec4 uBub[' + maxBubbles + '];',
            'uniform sampler2D uRing;',
            '',
            'float blob(vec2 p, vec4 b, vec4 m, float seed, float row, float tear) {',
            '    vec2 d = p - b.xy;',
            '    d.x /= 1.0 + m.w;',
            '    d.y /= 1.0 - m.w;',
            '    if (d.y < 0.0) d.y /= 1.0 + tear;',
            '    float a = atan(d.y, d.x), t = uP0.z;',
            '    float w = m.x * sin(2.0 * a + seed + t * 0.63)',
            '            + m.y * sin(3.0 * a + seed * 1.7 - t * 0.51)',
            '            + m.z * sin(5.0 * a + seed * 2.3 + t * 0.87)',
            '            + b.w * (sin(a + seed * 3.1) + 0.6 * sin(2.0 * a + seed * 5.3) + 0.35 * sin(4.0 * a + seed * 0.7))',
            '            + (texture2D(uRing, vec2(a * 0.15915494, row)).r - 0.5) * 0.5;',
            '    return length(d) - b.z * (1.0 + w);',
            '}',
            '',
            'float smin(float a, float b, float k) {',
            '    float h = clamp(0.5 + 0.5 * (b - a) / k, 0.0, 1.0);',
            '    return mix(b, a, h) - k * h * (1.0 - h);',
            '}',
            '',
            'float scene(vec2 p) {',
            '    float d = blob(p, uBlob[0], uMode[0], uSeed.x, 0.125, uP0.w);',
            '    if (uP1.y > 1.5) d = smin(d, blob(p, uBlob[1], uMode[1], uSeed.y, 0.375, 0.0), uP1.x);',
            '    if (uP1.y > 2.5) d = smin(d, blob(p, uBlob[2], uMode[2], uSeed.z, 0.625, 0.0), uP1.x);',
            '    return d;',
            '}',
            '',
            'vec2 local(vec2 p) {',
            '    vec2 q = (p - uBlob[0].xy) / uBlob[0].z, r;',
            '    if (uP1.y > 1.5) { r = (p - uBlob[1].xy) / uBlob[1].z; if (dot(r, r) < dot(q, q)) q = r; }',
            '    if (uP1.y > 2.5) { r = (p - uBlob[2].xy) / uBlob[2].z; if (dot(r, r) < dot(q, q)) q = r; }',
            '    return q;',
            '}',
            '',
            'float hash(float n) { return fract(sin(n * 12.9898) * 43758.5453); }',
            '',
            'void main() {',
            '    vec2 p = vec2(gl_FragCoord.x, uP0.y - gl_FragCoord.y);',
            '    float edge = uP1.z, time = uP0.z;',
            '    float d = scene(p);',
            '    if (d > edge * 1.6 * uP1.w + 1.0) discard;',
            '    vec2 g = vec2(scene(p + vec2(1.0, 0.0)) - d, scene(p + vec2(0.0, 1.0)) - d);',
            '    vec2 outward = g / max(length(g), 1e-4);',
            '',
            '    float u = clamp(-d / edge, 0.0, 1.0);',
            '    float c = 1.0 - u;',
            '    float slope = min(c / sqrt(max(1.0 - c * c, 1e-3)), 7.0);',
            '    vec3 n = normalize(vec3(outward * slope, 1.0));',
            '',
            '    float lit = dot(outward, vec2(0.56, 0.83)) * (1.0 - smoothstep(0.35, 0.85, u));',
            '    float side = clamp(dot(local(p), vec2(0.56, 0.83)), -1.0, 1.0);',
            '    float L = 0.93 - 0.045 * (0.5 + 0.5 * side) + 0.025 * smoothstep(0.2, 0.9, -side);',
            '    vec2 ep = p / (edge * 5.0);',
            '    float env = sin(ep.x * 1.7 + time * 0.13 + sin(ep.y * 1.3 - time * 0.11) * 1.5) * sin(ep.y * 1.9 - time * 0.09);',
            '    L -= 0.03 * smoothstep(0.3, 1.0, env) * smoothstep(0.4, 1.0, u);',
            '    L -= pow(1.0 - n.z, 1.2) * (0.34 + 0.26 * lit);',
            '    L = mix(L, 0.975, exp(-pow((u - 0.42) / 0.11, 2.0)) * max(lit, 0.0) * 0.55);',
            '    L = mix(L, mix(0.985, 0.66, smoothstep(-0.3, 0.6, lit)), smoothstep(-3.2, -0.8, d) * 0.75);',
            '    float win = smoothstep(0.35, 0.9, dot(outward, vec2(-0.8, -0.6)));',
            '    L = mix(L, 1.0, win * smoothstep(0.04, 0.14, u) * smoothstep(0.62, 0.26, u) * 0.95);',
            '    vec3 H = normalize(vec3(-0.42, -0.62, 0.66) + vec3(0.0, 0.0, 1.0));',
            '    L += pow(max(dot(n, H), 0.0), 90.0) * 1.4;',
            '    L = mix(L, 1.0, 0.45 * smoothstep(0.35, 0.8, u) * smoothstep(0.95, 0.55, u) * max(lit, 0.0));',
            '    vec2 cp = p / (edge * 2.2);',
            '    float cau = sin(cp.x * 1.3 + sin(cp.y * 0.9 + time * 0.7) * 1.6 + time * 0.45)',
            '              * sin(cp.y * 1.1 + sin(cp.x * 0.8 - time * 0.6) * 1.4 - time * 0.35);',
            '    L = mix(L, 1.0, pow(max(cau, 0.0), 3.0) * 0.45 * smoothstep(0.3, 0.9, u));',
            '    float pd = length(p - uPtr.xy);',
            '    float rip = sin(pd / (uPtr.w * 0.085) - time * 9.0) * exp(-pd / (uPtr.w * 0.5)) * uPtr.z;',
            '    L += 0.06 * rip * smoothstep(0.1, 0.5, u);',
            '',
            '    for (int i = 0; i < ' + maxBubbles + '; i++) {',
            '        vec4 b = uBub[i];',
            '        float on = fract(b.w) * 1.01;',
            '        if (on <= 0.0) continue;',
            '        vec2 q = (p - b.xy) / b.z;',
            '        float r = length(q);',
            '        if (r > 1.3) continue;',
            '        float sd = floor(b.w);',
            '        float inner = 0.42 + 0.3 * hash(sd), dark = 0.45 + 0.55 * hash(sd + 7.0);',
            '        float ang = 0.98 + (hash(sd + 13.0) - 0.5) * 1.3;',
            '        float px = 1.2 / b.z;',
            '        float away = max(dot(q / max(r, 1e-3), vec2(cos(ang), sin(ang))), 0.0);',
            '        float ring = smoothstep(1.0 + px, 1.0 - px, r) * smoothstep(inner - px, mix(inner, 1.0, 0.72), r);',
            '        L -= ring * mix(0.2, 1.0, away) * 0.68 * dark * on;',
            '        L = mix(L, 1.0, smoothstep(0.82, 0.15, r) * 0.5 * on);',
            '        L = mix(L, 1.0, smoothstep(0.78, inner + 0.1, r) * smoothstep(inner - 0.2, inner + 0.1, r) * away * 0.7 * on);',
            '    }',
            '',
            '    L = clamp(L, 0.0, 1.0);',
            '    float a = clamp((1.0 - L) / 0.76, 0.0, 1.0);',
            '    float milk = 0.94 * smoothstep(0.12, 0.6, u);',
            '    float cov = clamp(0.5 - d, 0.0, 1.0);',
            '    vec4 gel = vec4(vec3(0.235, 0.24, 0.255) * a + milk * (1.0 - a), a + milk * (1.0 - a)) * cov;',
            '    float sh = uP1.w * 0.035 * exp(-max(d, 0.0) / (edge * 0.25)) * (1.0 - cov) * smoothstep(0.0, 0.9, lit);',
            '    gl_FragColor = gel + vec4(0.0, 0.0, 0.0, sh) * (1.0 - gel.a);',
            '}'
        ].join('\n');
    }

    function rand(a, b) { return a + Math.random() * (b - a); }
    function wrap(a) { return a - TAU * Math.floor((a + Math.PI) / TAU); }

    var PTR = { on: false, touch: false, x: 0, y: 0, down: 0 };
    function track() {
        function mouse(e) {
            if (e.pointerType === 'touch') return;
            PTR.on = true; PTR.touch = false; PTR.x = e.clientX; PTR.y = e.clientY;
        }
        function finger(e) {
            var t = e.touches && e.touches[0];
            if (!t) return;
            if (e.type === 'touchstart') PTR.down++;
            PTR.on = true; PTR.touch = true; PTR.x = t.clientX; PTR.y = t.clientY;
        }
        function off() { PTR.on = false; }
        window.addEventListener('pointermove', mouse, { passive: true });
        window.addEventListener('pointerdown', mouse, { passive: true });
        window.addEventListener('touchstart', finger, { passive: true });
        window.addEventListener('touchmove', finger, { passive: true });
        window.addEventListener('touchend', off, { passive: true });
        window.addEventListener('touchcancel', off, { passive: true });
        window.addEventListener('blur', off);
        document.addEventListener('mouseleave', off);
        track = function () {};
    }

    function Gel(canvas, img) {
        var scene = SCENES[canvas.getAttribute('data-v11-gel')];
        if (!scene) throw new Error('unknown gel scene');
        var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, powerPreference: 'low-power' });
        if (!gl) throw new Error('no WebGL');

        var budget = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS) || 64;
        var max = Math.max(8, Math.min(scene.bubbles.count, budget - 14));

        function shader(type, src) {
            var s = gl.createShader(type);
            gl.shaderSource(s, src);
            gl.compileShader(s);
            if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
            return s;
        }
        var prog = gl.createProgram();
        gl.attachShader(prog, shader(gl.VERTEX_SHADER, VERT));
        gl.attachShader(prog, shader(gl.FRAGMENT_SHADER, fragment(max)));
        gl.linkProgram(prog);
        if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
        gl.useProgram(prog);
        gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
        var at = gl.getAttribLocation(prog, 'a');
        gl.enableVertexAttribArray(at);
        gl.vertexAttribPointer(at, 2, gl.FLOAT, false, 0, 0);
        var U = {};
        ['uP0', 'uP1', 'uBlob', 'uMode', 'uSeed', 'uPtr', 'uBub', 'uRing'].forEach(function (k) {
            U[k] = gl.getUniformLocation(prog, k);
        });

        this.ringBytes = new Uint8Array(RING * 4);
        for (var j = 0; j < this.ringBytes.length; j++) this.ringBytes[j] = 128;
        gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
        gl.bindTexture(gl.TEXTURE_2D, gl.createTexture());
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, RING, 4, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, this.ringBytes);
        gl.uniform1i(U.uRing, 0);

        this.canvas = canvas;
        this.img = img;
        this.gl = gl;
        this.U = U;
        this.scene = scene;
        this.max = max;
        this.blobs = scene.blobs.map(function (b) {
            return { b: b, sq: 0, sqv: 0, ex: 0, px: rand(0, TAU), py: rand(0, TAU) };
        });
        this.h = new Float32Array(RING * 3);
        this.hv = new Float32Array(RING * 3);
        this.bubbles = [];
        for (var i = 0; i < max; i++) this.bubbles.push(this.spawn(true));
        this.v = 0;
        this.tear = 0;
        this.lag = 0;
        this.lagv = 0;
        this.t0 = 0;
        this.last = 0;
        this.ptrPrev = null;
        this.ptrDown = -1;
        this.ripple = 0;
        this.ripX = 0;
        this.ripY = 0;
        this.blobData = new Float32Array(12);
        this.modeData = new Float32Array(12);
        this.bubData = new Float32Array(max * 4);
        this.centres = [[0, 0, 1], [0, 0, 1], [0, 0, 1]];
        this.fit();
    }

    Gel.prototype.spawn = function (anywhere) {
        var sc = this.scene.bubbles, blobs = this.blobs, total = 0, pick, k = 0, i;
        for (i = 0; i < blobs.length; i++) total += blobs[i].b.r * blobs[i].b.r;
        pick = Math.random() * total;
        for (i = 0; i < blobs.length; i++) {
            pick -= blobs[i].b.r * blobs[i].b.r;
            if (pick <= 0) { k = i; break; }
        }
        var s = sc.min * Math.pow(sc.max / sc.min, Math.pow(Math.random(), 2.3));
        if (blobs[k].b.r < 0.12) s = Math.min(s * 1.5, 0.2);
        var lim = 0.74 - s, x, y, ang, rad;
        var friend = this.bubbles && this.bubbles.length && Math.random() < 0.15 ? this.bubbles[(Math.random() * this.bubbles.length) | 0] : null;
        if (friend && friend.k === k && !friend.dying) {
            ang = rand(0, TAU);
            x = friend.x + Math.cos(ang) * (friend.s + s) * 1.06;
            y = friend.y + Math.sin(ang) * (friend.s + s) * 1.06;
        } else {
            ang = rand(0, TAU);
            rad = lim * Math.sqrt(Math.random());
            x = Math.cos(ang) * rad;
            y = Math.sin(ang) * rad;
            if (!anywhere && Math.random() < 0.55) y = Math.abs(y);
        }
        var speck = s < 0.02 && Math.random() < 0.5;
        return {
            k: k, s: s, x: x, y: y, ox: 0, oy: 0, ovx: 0, ovy: 0,
            seed: (Math.random() * 97) | 0,
            rise: (0.006 + 5 * s * s) * rand(0.5, 1.6),
            trapped: Math.random() < 0.3,
            amp: rand(0.004, 0.03), f1: rand(0.15, 0.9), f2: rand(0.4, 1.7), p1: rand(0, TAU), p2: rand(0, TAU),
            life: speck ? rand(1.2, 5) : rand(7, 40), age: anywhere ? rand(0, 6) : 0,
            fadeIn: speck ? rand(0.2, 0.6) : rand(0.6, 1.6),
            a: anywhere ? 1 : 0, dying: false
        };
    };

    Gel.prototype.fit = function () {
        var img = this.img, c = this.canvas, m = this.scene.margin;
        var w = img.offsetWidth, h = img.offsetHeight;
        if (!w || !h) return;
        c.style.left = (img.offsetLeft - m * w) + 'px';
        c.style.top = (img.offsetTop - m * h) + 'px';
        c.style.width = w * (1 + 2 * m) + 'px';
        c.style.height = h * (1 + 2 * m) + 'px';
        var cw = w * (1 + 2 * m), ch = h * (1 + 2 * m), dpr = Math.min(window.devicePixelRatio || 1, 2);
        if (cw * ch * dpr * dpr > 1.3e6) dpr = Math.sqrt(1.3e6 / (cw * ch));
        c.width = Math.max(1, Math.round(cw * dpr));
        c.height = Math.max(1, Math.round(ch * dpr));
        this.gl.viewport(0, 0, c.width, c.height);
    };

    Gel.prototype.motion = function (v) { this.v = v; };

    Gel.prototype.push = function (j, angle, inward, width) {
        var off = j * RING;
        for (var i = 0; i < RING; i++) {
            var da = wrap((i + 0.5) / RING * TAU - angle) / width;
            if (da > -3 && da < 3) this.hv[off + i] -= inward * Math.exp(-da * da);
        }
    };

    Gel.prototype.land = function () {
        this.blobs[0].sqv += 1.5;
        this.blobs[0].ex = 0.03;
        this.push(0, Math.PI / 2, 0.9, 0.5);
        this.lagv += 1.1;
    };

    Gel.prototype.nudge = function (amount) {
        for (var i = 0; i < this.blobs.length; i++) {
            this.blobs[i].sqv += amount * (i ? 0.8 : 0.5);
            this.push(i, amount > 0 ? -Math.PI / 2 : Math.PI / 2, Math.abs(amount) * 0.5, 0.9);
        }
        this.lagv += amount * 0.6;
    };

    Gel.prototype.pointer = function (dt) {
        if (!PTR.on || !dt) { this.ptrPrev = null; return null; }
        var rect = this.canvas.getBoundingClientRect();
        if (!rect.width) return null;
        var sx = this.canvas.width / rect.width, sy = this.canvas.height / rect.height;
        var px = (PTR.x - rect.left) * sx, py = (PTR.y - rect.top) * sy;
        var here = PTR.touch ? [PTR.x * sx, PTR.y * sy] : [px, py];
        var prev = this.ptrPrev;
        this.ptrPrev = here;
        if (PTR.touch && this.ptrDown !== PTR.down) { this.ptrDown = PTR.down; return null; }
        if (!prev) return null;
        var vx = (here[0] - prev[0]) / dt, vy = (here[1] - prev[1]) / dt;
        if (vx * vx + vy * vy < 900) return null;
        return { x0: PTR.touch ? px : prev[0], y0: PTR.touch ? py : prev[1], x: px, y: py, vx: vx, vy: vy };
    };

    Gel.prototype.place = function (time) {
        var sc = this.scene, m = sc.margin, W = this.canvas.width, H = this.canvas.height;
        var boxW = W / (1 + 2 * m), boxH = H / (1 + 2 * m);
        for (var j = 0; j < 3; j++) {
            var b = this.blobs[j] || this.blobs[0], C = this.centres[j];
            C[0] = (m + b.b.x + b.b.drift * Math.sin(time * 0.37 + b.px)) * boxW;
            C[1] = (m + b.b.y) * boxH + b.b.drift * boxW * Math.cos(time * 0.29 + b.py);
            C[2] = b.b.r * boxW;
            if (sc === SCENES.drop) C[1] += C[2] * b.sq;
        }
    };

    Gel.prototype.touch = function (x, y, vx, vy, dt) {
        var n = this.blobs.length, j, i;
        for (j = 0; j < n; j++) {
            var C = this.centres[j], dx = x - C[0], dy = y - C[1], dist = Math.sqrt(dx * dx + dy * dy) || 1;
            var rim = dist / C[2] - 1, near = Math.exp(-(rim / REACH) * (rim / REACH));
            if (near > 0.02) {
                var ux = dx / dist, uy = dy / dist;
                var vr = (vx * ux + vy * uy) / C[2], vt = (vy * ux - vx * uy) / C[2];
                var ang = Math.atan2(dy, dx), off = j * RING;
                for (i = 0; i < RING; i++) {
                    var da = wrap((i + 0.5) / RING * TAU - ang) / 0.3;
                    if (da < -3 || da > 3) continue;
                    var g = Math.exp(-da * da);
                    this.hv[off + i] += (vr * g - vt * 0.8 * da * g) * POKE * near * dt;
                }
                this.blobs[j].sqv += vy / C[2] * 0.05 * near * dt;
            }
            if (rim < 0.05) {
                var o = j * RING;
                for (i = 0; i < RING; i++) {
                    var th = (i + 0.5) / RING * TAU, nx = Math.cos(th), ny = Math.sin(th);
                    var ex = C[0] + nx * C[2] - x, ey = C[1] + ny * C[2] - y;
                    var wgt = Math.exp(-(ex * ex + ey * ey) / (0.9 * C[2] * C[2]));
                    this.hv[o + i] += (vx * nx + vy * ny) / C[2] * wgt * DRAG * dt;
                }
            }
            if (rim < 0.15) {
                this.ripple = Math.min(1, this.ripple + Math.sqrt(vx * vx + vy * vy) / C[2] * 0.6 * dt);
                this.ripX = x;
                this.ripY = y;
            }
        }
        for (i = 0; i < this.bubbles.length; i++) {
            var q = this.bubbles[i], Q = this.centres[q.k];
            var bx = Q[0] + (q.x + q.ox) * Q[2] - x, by = Q[1] + (q.y + q.oy) * Q[2] - y;
            var wb = Math.exp(-(bx * bx + by * by) / (0.2 * Q[2] * Q[2]));
            if (wb < 0.01) continue;
            q.ovx += vx / Q[2] * wb * B_PUSH * dt;
            q.ovy += vy / Q[2] * wb * B_PUSH * dt;
        }
    };

    Gel.prototype.step = function (dt, time) {
        var n = this.blobs.length, hs = this.h, hv = this.hv, i, j, b;
        var steps = Math.ceil(dt * 120), h = dt / (steps || 1);
        for (var st = 0; st < steps; st++) {
            for (j = 0; j < n; j++) {
                var o = j * RING, mean = 0;
                for (i = 0; i < RING; i++) {
                    var lap = hs[o + (i + RING - 1) % RING] + hs[o + (i + 1) % RING] - 2 * hs[o + i];
                    hv[o + i] += (-STIFF * hs[o + i] - DAMP * hv[o + i] + TENSION * lap) * h;
                }
                for (i = 0; i < RING; i++) {
                    hs[o + i] = Math.max(-0.22, Math.min(0.22, hs[o + i] + hv[o + i] * h));
                    mean += hs[o + i];
                }
                mean /= RING;
                for (i = 0; i < RING; i++) hs[o + i] -= mean;
            }
        }

        for (j = 0; j < n; j++) {
            b = this.blobs[j];
            b.sqv += (-190 * b.sq - 7.5 * b.sqv) * dt;
            b.sq += b.sqv * dt;
            b.ex *= Math.exp(-dt / 0.7);
        }
        var target = Math.max(-0.14, Math.min(0.14, -this.v / 2600));
        this.lagv += ((target - this.lag) * 90 - 8 * this.lagv) * dt;
        this.lag += this.lagv * dt;
        this.tear += (Math.min(Math.abs(this.v) / 2400, 0.2) - this.tear) * (1 - Math.exp(-dt / 0.08));
        this.ripple *= Math.exp(-dt / 0.7);

        for (i = 0; i < this.bubbles.length; i++) {
            var p = this.bubbles[i], lim = 0.76 - p.s;
            var fx = 0.02 * Math.sin(1.9 * p.y + time * 0.23 + p.k * 1.7);
            var fy = 0.015 * Math.sin(1.6 * p.x - time * 0.19 + p.k);
            var mx = p.amp * (Math.cos(time * p.f1 + p.p1) * p.f1 + 0.5 * Math.cos(time * p.f2 + p.p2) * p.f2);
            var my = p.amp * 0.6 * Math.cos(time * p.f2 * 0.7 + p.p1) * p.f2;
            var still = p.trapped ? 0.15 : 1;
            p.x += (fx + mx) * still * dt;
            p.y += ((fy + my) * still - p.rise * (p.trapped ? 0.06 : 1)) * dt;
            p.ovx += (-B_STIFF * p.ox - B_DAMP * p.ovx) * dt;
            p.ovy += (-B_STIFF * p.oy - B_DAMP * p.ovy) * dt;
            p.ox += p.ovx * dt;
            p.oy += p.ovy * dt;
            p.age += dt;
            if (!p.dying && (p.age > p.life || p.x * p.x + p.y * p.y > lim * lim)) p.dying = true;
            p.a = Math.min(1, p.a + (p.dying ? -1 / 0.6 : 1 / p.fadeIn) * dt);
            if (p.a <= 0) this.bubbles[i] = this.spawn(false);
        }
    };

    Gel.prototype.render = function (time) {
        var gl = this.gl, U = this.U, sc = this.scene, W = this.canvas.width, H = this.canvas.height;
        var boxW = W / (1 + 2 * sc.margin), n = this.blobs.length, i, j;

        for (j = 0; j < n; j++) {
            for (i = 0; i < RING; i++) this.ringBytes[j * RING + i] = Math.max(0, Math.min(255, Math.round((this.h[j * RING + i] * 2 + 0.5) * 255)));
        }
        gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, RING, 4, gl.LUMINANCE, gl.UNSIGNED_BYTE, this.ringBytes);

        for (j = 0; j < 3; j++) {
            var b = this.blobs[j] || this.blobs[0], C = this.centres[j], jig = b.ex * Math.sin(time * 11 + j);
            this.blobData.set([C[0], C[1], C[2], b.b.odd || 0], j * 4);
            this.modeData.set([0.016 + jig, 0.011 + jig * 0.6, 0.005 + jig * 0.4, Math.max(-0.2, Math.min(0.2, b.sq))], j * 4);
        }

        var bub = this.bubData;
        for (i = 0; i < this.bubbles.length; i++) {
            var p = this.bubbles[i], Q = this.centres[p.k], ease = p.a * p.a * (3 - 2 * p.a);
            bub[i * 4] = Q[0] + (p.x + p.ox) * Q[2];
            bub[i * 4 + 1] = Q[1] + (p.y + p.oy + this.lag * (0.6 + p.s * 3)) * Q[2];
            bub[i * 4 + 2] = Math.max(0.6, p.s * Q[2] * (0.6 + 0.4 * ease));
            bub[i * 4 + 3] = p.seed * 2 + Math.min(ease, 0.99);
        }

        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.uniform4f(U.uP0, W, H, time, sc === SCENES.drop ? this.tear : 0);
        gl.uniform4f(U.uP1, sc.k * boxW, n, sc.edge * sc.blobs[0].r * boxW, sc.shadow);
        gl.uniform4fv(U.uBlob, this.blobData);
        gl.uniform4fv(U.uMode, this.modeData);
        gl.uniform3f(U.uSeed, sc.blobs[0].seed, (sc.blobs[1] || sc.blobs[0]).seed, (sc.blobs[2] || sc.blobs[0]).seed);
        gl.uniform4f(U.uPtr, this.ripX, this.ripY, this.ripple, sc.blobs[0].r * boxW);
        gl.uniform4fv(U.uBub, bub);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
    };

    Gel.prototype.frame = function (now) {
        var t = now / 1000, dt = this.last ? Math.min(t - this.last, 0.05) : 0;
        this.last = t;
        if (!this.t0) this.t0 = t - rand(0, 20);
        var time = t - this.t0;
        this.place(time);
        var ptr = this.pointer(dt);
        if (ptr) {
            var small = this.centres[0][2];
            for (var j = 1; j < this.blobs.length; j++) small = Math.min(small, this.centres[j][2]);
            var len = Math.sqrt((ptr.x - ptr.x0) * (ptr.x - ptr.x0) + (ptr.y - ptr.y0) * (ptr.y - ptr.y0));
            var hops = Math.max(1, Math.min(32, Math.ceil(len / (0.1 * small))));
            for (var k = 1; k <= hops; k++) {
                this.touch(ptr.x0 + (ptr.x - ptr.x0) * k / hops, ptr.y0 + (ptr.y - ptr.y0) * k / hops, ptr.vx, ptr.vy, dt / hops);
            }
        }
        this.step(dt, time);
        this.render(time);
    };

    function mount(canvas) {
        if (canvas.hasAttribute('data-gel-mounted')) return;
        canvas.setAttribute('data-gel-mounted', '');
        if (!window.matchMedia || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;
        var host = canvas.parentNode, img = host.querySelector('img'), gel;
        if (!img) return;
        try { gel = new Gel(canvas, img); } catch (e) { return; }
        track();

        var raf = 0, near = false, lastY = window.scrollY, lastT = 0, isCluster = gel.scene === SCENES.cluster;
        function loop(now) {
            raf = 0;
            if (!near || !host.v11gel) return;
            if (isCluster) {
                var y = window.scrollY, dt = lastT ? (now - lastT) / 1000 : 0;
                if (dt > 0) {
                    var vel = (y - lastY) / dt;
                    if (Math.abs(vel) > 250) gel.nudge(Math.max(-0.6, Math.min(0.6, vel / 4000)) * dt * 10);
                }
                lastY = y;
                lastT = now;
            }
            gel.frame(now);
            raf = requestAnimationFrame(loop);
        }
        new IntersectionObserver(function (entries) {
            near = entries[entries.length - 1].isIntersecting;
            if (near && !raf) {
                gel.last = 0;
                lastT = 0;
                raf = requestAnimationFrame(loop);
            }
        }, { rootMargin: '25% 0px' }).observe(host);
        function refit() { gel.fit(); if (host.v11gel) gel.frame(performance.now()); }
        if ('ResizeObserver' in window) new ResizeObserver(refit).observe(img);
        img.addEventListener('load', refit);
        canvas.addEventListener('webglcontextlost', function (e) {
            e.preventDefault();
            host.v11gel = null;
            host.classList.remove('is-gel');
        });

        host.v11gel = gel;
        gel.frame(performance.now());
        host.classList.add('is-gel');
    }

    function all() {
        var list = document.querySelectorAll('canvas[data-v11-gel]');
        for (var i = 0; i < list.length; i++) mount(list[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
    else all();
    document.addEventListener('shopify:section:load', all);
})();
